import React from 'react';
import { Box, Card, CardContent, CardActions, Typography, Button } from '@mui/material';
import { Capacitor } from '@capacitor/core';
import { InAppBrowser } from '@capacitor/inappbrowser';
import { useTranslation } from 'react-i18next';
import concordareIcon from '../assets/images/concordare-icon.png';

// Cross-promotion banner for "Concordare", another game by the same
// developer. On native it is only shown in portrait (see sx below) where the
// home screen has room below the two main cards; landscape stays as-is to
// avoid crowding the game mode buttons. On web, `alwaysVisible` shows it in
// any orientation.
const openExternalUrl = async (url) => {
    if (Capacitor.isNativePlatform()) {
        try {
            await InAppBrowser.openInExternalBrowser({ url });
        } catch (error) {
            console.error('Error opening external URL:', error);
            window.open(url, '_blank');
        }
    } else {
        window.open(url, '_blank');
    }
};

const CONCORDARE_WEB_URL = 'https://concordare.es';

const getConcordareUrl = () => {
    const appStoreUrl = process.env.REACT_APP_CONCORDARE_APP_STORE_URL;
    const playStoreUrl = process.env.REACT_APP_CONCORDARE_GOOGLE_PLAY_URL;
    const platform = Capacitor.getPlatform();

    if (platform === 'ios') return appStoreUrl;
    if (platform === 'android') return playStoreUrl;

    // Web: send visitors to the game's website.
    return CONCORDARE_WEB_URL;
};

const ConcordarePromo = ({ alwaysVisible = false }) => {
    const { t } = useTranslation();

    const handleClick = () => {
        const url = getConcordareUrl();
        if (url) {
            openExternalUrl(url);
        }
    };

    return (
        <Box
            sx={{
                display: alwaysVisible ? 'block' : 'none',
                '@media (orientation: portrait)': { display: 'block' },
                width: '100%',
                mt: 1.5,
            }}
        >
            <Card elevation={3}>
                <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 1.5, pb: 1 }}>
                    <Box
                        component="img"
                        src={concordareIcon}
                        alt="Concordare"
                        sx={{ width: 48, height: 48, borderRadius: 1.5, flexShrink: 0 }}
                    />
                    <Box sx={{ minWidth: 0 }}>
                        <Typography variant="subtitle2" sx={{ fontWeight: 700, fontSize: '0.85rem' }}>
                            {t('crossPromo.title')}
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.75rem', lineHeight: 1.3 }}>
                            {t('crossPromo.description')}
                        </Typography>
                    </Box>
                </CardContent>
                <CardActions sx={{ pt: 0, px: 2, pb: 1.5 }}>
                    <Button fullWidth variant="contained" size="small" onClick={handleClick}>
                        {t('crossPromo.cta')}
                    </Button>
                </CardActions>
            </Card>
        </Box>
    );
};

export default ConcordarePromo;
